var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCauseBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 15,
    viewBox: "0 0 28 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5H23.3724C23.6973 0.5 24.0133 0.605453 24.2731 0.800503L26.9007 2.77349C27.278 3.0568 27.5 3.50114 27.5 3.97299V11.1936C27.5 11.6839 27.2604 12.1432 26.8583 12.4237L24.2693 14.2302C24.0175 14.4058 23.7179 14.5 23.4109 14.5H2C1.17157 14.5 0.5 13.8284 0.5 13V2C0.5 1.17157 1.17157 0.5 2 0.5Z",
    stroke: "#00223A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCauseBox);
export default __webpack_public_path__ + "static/media/cause-box.b3055029b549c6e22d048179fa9949cb.svg";
export { ForwardRef as ReactComponent };